import {
  IntegerInputControl,
  RealInputControl,
} from '../../../../../../types/types';

export const getReplaceRegex = (
  control: IntegerInputControl | RealInputControl,
  isFloat: boolean
) => {
  if (isFloat) {
    return /[^0-9-.,]+/g;
  }

  if (control.type === 'integer') {
    return /[^0-9-]+/g;
  }

  return /[^0-9-.]+/g;
};
